module.exports = __webpack_public_path__ + "img/BETR.d2d5c66e.svg";